import React from 'react';

import { Text } from 'Components/Base';

export const TextTitle = (props) => {
  return <Text textStyle="heading4" fontWeight="bolder" {...props} />;
};

export const TextSubTitle = (props) => {
  return <Text textStyle="subtitle1" fontWeight="bolder" {...props} />;
};

export const TextDescription = (props) => {
  return <Text mt={1} fontWeight="normal" {...props} />;
};
